export const NIGER_CITIES = [
  "Niamey",
  "Zinder",
  "Maradi",
  "Agadez",
  "Tahoua",
  "Dosso",
  "Diffa",
  "Tillaberi",
];
